import { useEffect } from 'react';
import { Box, Card, Title, Text } from '@nimbus-ds/components';
import { DataList } from '@nimbus-ds/patterns';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';
import { useOrderSubscriptionsByOrder } from 'domains/Subscriptions/hooks/useOrderSubscription';

interface CardSubscriptionProps {
  orderId: string;
}

function CardSubscription({ orderId }: Readonly<CardSubscriptionProps>) {
  const { items, hasSubscriptions, fetchSubscriptions } =
    useOrderSubscriptionsByOrder(orderId);
  const t = useTranslationOrders();
  useEffect(() => {
    fetchSubscriptions();
  }, [fetchSubscriptions]);

  if (!hasSubscriptions) {
    return null;
  }

  const sub = items?.[0];
  if (!sub?.subscriptionOption) {
    return null;
  }

  return (
    <Card padding="none">
      <Card.Header padding="base">
        <Title as="h4">{t('cardSubscription.title')}</Title>
      </Card.Header>
      <Card.Body>
        <DataList.Row key={sub.id} gap="1">
          <Box display="flex" justifyContent="space-between">
            <Text fontWeight="regular" fontSize="base" color="neutral-textHigh">
              {t('cardSubscription.idSubscription')}
            </Text>
            <Text fontWeight="regular" fontSize="base" color="neutral-textHigh">
              {sub.id}
            </Text>
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Text fontWeight="regular" fontSize="base" color="neutral-textHigh">
              {t('cardSubscription.frequency')}
            </Text>
            <Text fontWeight="regular" fontSize="base" color="neutral-textHigh">
              {sub.subscriptionOption.frequencyParam}{' '}
              {t(
                `cardSubscription.frequencyType.${sub.subscriptionOption.frequencyType}`,
              )}
            </Text>
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Text fontWeight="regular" fontSize="base" color="neutral-textHigh">
              {t('cardSubscription.discount')}
            </Text>
            <Text fontWeight="regular" fontSize="base" color="neutral-textHigh">
              {sub.subscriptionOption.discountPercentage}%
            </Text>
          </Box>
        </DataList.Row>
      </Card.Body>
    </Card>
  );
}

export default CardSubscription;
